import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut, doDownload, doPostDownload } from './utils'

// const API_ROOT2 = 'http://localhost:9009/api'

export const getEfilling = (pageNumber, pageSize) => {
  const url = `${API_ROOT}/v1/accounting/e-filling/page/${pageNumber}/${pageSize}`
  return doGet(url)
}
export const searchEfilling = (request, pageNumber, pageSize) => {
  const url = `${API_ROOT}/v1/accounting/e-filling/search/${pageNumber}/${pageSize}`
  return doPost(url, request)
}

export const saveEfilling = (request) => {
  const url = `${API_ROOT}/v1/accounting/e-filling/save`
  return doPost(url, request)
}

export const deleteEfilling = (id) => {
  const url = `${API_ROOT}/v1/accounting/e-filling/${id}`
  return doDelete(url)
}

export const editEfilling = (id) => {
  const url = `${API_ROOT}/v1/accounting/e-filling/${id}`
  return doGet(url)
}

export const UpdateEfilling = (request) => {
  const url = `${API_ROOT}/v1/accounting/e-filling/update`
  return doPut(url, request)
}

export const downloadEfillingFileByPath = (pathFile) => {
  const url = `${API_ROOT}/v1/accounting/download/file?filePath=${pathFile}`
  return doDownload(url)
}

export const downloadFormEfillingFileByPath = (accountingEfillingSubmitId, taxType) => {
  const url = `${API_ROOT}/v1/accounting/e-filling/export/text/${accountingEfillingSubmitId}/${taxType}`
  return doDownload(url)
}

export const preeviewEditEfilling = (id) => {
  const url = `${API_ROOT}/v1/accounting/e-filling/${id}/detail`
  return doGet(url)
}

// API e-filling-list-report

export const getEfillingReport = (request, pageNumber, pageSize) => {
  const url = `${API_ROOT}/v1/accounting/e-filling/report/search/${pageNumber}/${pageSize}`
  return doPost(url, request)
}
export const searchEfillingReport = (request, pageNumber, pageSize) => {
  const url = `${API_ROOT}/v1/accounting/e-filling/report/search/${pageNumber}/${pageSize}`
  return doPost(url, request)
}

export const ExportEfillingReport = (request) => {
  const url = `${API_ROOT}/files/download/e-filling`
  return doPostDownload(url, request)
}

// API e-filling-summary-report

export const getEfillingSummaryReport = (projectCode) => {
  // const API_ROOT = 'http://localhost:9014/api'
  const url = `${API_ROOT}/v1/accounting/e-filling/summary-report/page/?projectCode=${projectCode}`
  return doGet(url)
}

export const searchEfillingSummaryReport = (request) => {
  const url = `${API_ROOT}/v1/accounting/e-filling/summary-report/search`
  return doPost(url, request)
}

export const exportEfillingSummaryReport = (request) => {
  const url = `${API_ROOT}/v1/accounting/e-filling/summary-report/export/excel`
  return doPostDownload(url, request)
}

//API นำส่งภาษีรายปี
export const getAnnualTaxRemittance = (request) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/accounting/e-filling/annual-tax/search`
  return doPost(url, request)
}

export const saveAnnualTaxRemittance = (request) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/accounting/e-filling/annual-tax/save`
  return doPost(url, request)
}

export const exportAnnualTaxRemittance = (request) => {
  const url = `${API_ROOT}/v1/accounting/e-filling/annual-tax/export/excel`
  return doPostDownload(url, request)
}

export const exportAnnualTaxRemittanceText = (request) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/accounting/e-filling/annual-tax/export/text`
  return doPostDownload(url, request)
}
